/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search tools`)
};

const es_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar herramientas`)
};

const de_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools durchsuchen`)
};

const nl_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools zoeken`)
};

const fr_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des outils`)
};

const it_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca strumenti`)
};

const pt_br2_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar ferramentas`)
};

const pt_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar ferramentas`)
};

const ja_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツールを検索`)
};

const zh_search_aria_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const search_aria_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.search_aria_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("search_aria_label", locale)
	if (locale === "en") return en_search_aria_label(inputs)
	if (locale === "es") return es_search_aria_label(inputs)
	if (locale === "de") return de_search_aria_label(inputs)
	if (locale === "nl") return nl_search_aria_label(inputs)
	if (locale === "fr") return fr_search_aria_label(inputs)
	if (locale === "it") return it_search_aria_label(inputs)
	if (locale === "pt-BR") return pt_br2_search_aria_label(inputs)
	if (locale === "pt") return pt_search_aria_label(inputs)
	if (locale === "ja") return ja_search_aria_label(inputs)
	return zh_search_aria_label(inputs)
};